<!-- apps/web/src/components/icons/IconBrand.vue -->
<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M3 11.5L12 4l9 7.5" />
    <path d="M5 10v10h14V10" />
    <circle cx="12" cy="14" r="2.2" fill="currentColor" stroke="none"/>
  </svg>
</template>
